import sha1 from 'js-sha1';
import { IS_MOBILE_OR_TABLET_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { sendSuperAppXray, superAppSubmetrics } from 'reactApp/appHelpers/sendSuperAppAnalytics';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { getFacesList } from 'reactApp/modules/faces/faces.selectors';
import { getCurrentPublicItem, isOwnPublic } from 'reactApp/modules/public/public.selectors';
import type { PublicFolder } from 'reactApp/modules/public/public.types';
import { isPublicAlbumTemporaryUrl } from 'reactApp/modules/public/publicAlbum.helper.store';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { type SnackbarItem, SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { store as reduxStore } from 'reactApp/store';
import { copy as copyToClipboard } from 'reactApp/utils/copyToClipboard';
import { EQueryParams } from 'server/helpers/getRequestParams';

import { encodePublicUrlOnTouch } from '../featuresHelpers/features/encodePublicUrlOnTouch';

export const shareLink = ({
    id,
    url,
    useNativeShare = true,
    successSnackbar,
}: {
    id?: string;
    url?: string;
    useNativeShare?: boolean;
    successSnackbar?: SnackbarItem;
}): void => {
    const state = reduxStore.getState();
    const storage = getCurrentStorage(state);

    const isNativeShareSupported = IS_MOBILE_OR_TABLET_BROWSER && 'share' in navigator && typeof navigator.share === 'function';

    const currentStorage = isPublicAlbumTemporaryUrl() ? 'album' : storage;

    const href = id ? `${window.location.origin}/${currentStorage}/${id}` : window.location.href;
    const copyUrl = encodePublicUrlOnTouch ? encodeURI(url || href) : url || href;

    const fromDeeplink = getQueryParams()[EQueryParams.fromDeeplink];
    const isSuperAppWebView = Boolean(IS_WEBVIEW) && fromDeeplink;

    const item = getCurrentPublicItem(state) as PublicFolder;
    const isOwn = isOwnPublic(state);
    const faces = getFacesList(state);

    if (isSuperAppWebView) {
        sendSuperAppXray(superAppSubmetrics.sharePublic, {
            id_public: isOwn && item?.home ? sha1(item.home) : item?.id,
            id_folder: item?.id,
            type_public: 'folder',
            count_objects: item?.count?.all,
            owner: isOwn,
            have_faces: Boolean(faces?.length),
            count_faces: faces?.length,
        });
    }

    if (isNativeShareSupported && useNativeShare) {
        navigator.share({ url: copyUrl }).catch(() => {});
        return;
    }

    copyToClipboard(copyUrl)
        .then(({ hasBeenCopied }) => {
            if (hasBeenCopied) {
                const snackbar = successSnackbar || {
                    id: 'copy-link',
                    closable: true,
                    text: 'Ссылка успешно скопирована',
                    type: SnackbarTypes.success,
                };

                reduxStore.dispatch(showSnackbarAction(snackbar));
            }
        })
        .catch(() => {
            reduxStore.dispatch(
                showSnackbarAction({
                    id: 'copy-link',
                    closable: true,
                    text: 'Не удалось скопировать ссылку',
                    type: SnackbarTypes.failure,
                })
            );
        });
};
